<template lang="pug">
div
  Form(:data="location", :isSubmitting="isSubmitting", @submit="create")
</template>

<script>
import { ref } from '@vue/composition-api'
import Form from '../shared/Form.vue'
// eslint-disable-next-line import/no-cycle
import useLocationAdd from './useLocationAdd'

export default {
  components: {
    Form,
  },

  setup() {
    const { create, location, isSubmitting } = useLocationAdd()

    return {
      location,
      create,
      isSubmitting,
    }
  },
}
</script>
